import { render, staticRenderFns } from "./question-dialog.vue?vue&type=template&id=30f3fd27"
import script from "./question-dialog.vue?vue&type=script&lang=js"
export * from "./question-dialog.vue?vue&type=script&lang=js"
import style0 from "./question-dialog.vue?vue&type=style&index=0&id=30f3fd27&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports